import {
  CoverageDLossOfUseValue,
  CoverageEarthquakeValue,
  CoverageInflationGuardValue,
  CoverageWaterDamageValue,
} from "@covertree/new-business-graphql";
import {
  CoverageAccessor,
  ExtraCoverageAccessor,
  PackageCoverageAccessor,
} from "../..";

export function mapStringToPercentEnum(
  value: string,
  accessor: CoverageAccessor
):
  | CoverageDLossOfUseValue
  | CoverageEarthquakeValue
  | CoverageInflationGuardValue
  | CoverageWaterDamageValue {
  if (accessor === PackageCoverageAccessor.InflationGuard) {
    switch (value) {
      case "3%":
        return CoverageInflationGuardValue.Percent3;
      default:
        throw new Error("Unknown value for CoverageInflationGuard");
    }
  }

  if (accessor === PackageCoverageAccessor.LossOfUse) {
    switch (value) {
      case "10%":
        return CoverageDLossOfUseValue.Percent10;
      case "20%":
        return CoverageDLossOfUseValue.Percent20;
      case "30%":
        return CoverageDLossOfUseValue.Percent30;
      case "40%":
        return CoverageDLossOfUseValue.Percent40;
      default:
        throw new Error("Unknown value for CoverageDLossOfUse");
    }
  }

  if (accessor === ExtraCoverageAccessor.EarthquakeCoverage) {
    switch (value) {
      case "10%":
        return CoverageEarthquakeValue.Percent10;
      case "15%":
        return CoverageEarthquakeValue.Percent15;
      case "20%":
        return CoverageEarthquakeValue.Percent20;
      default:
        throw new Error("Unknown value for CoverageEarthquake");
    }
  }

  if (accessor === PackageCoverageAccessor.WaterDamage) {
    switch (value) {
      case "10%":
        return CoverageWaterDamageValue.Percent10;
      case "25%":
        return CoverageWaterDamageValue.Percent25;
      case "50%":
        return CoverageWaterDamageValue.Percent50;
      case "Full Coverage":
        return CoverageWaterDamageValue.FullCoverage;
      default:
        throw new Error("Unknown value for CoverageWaterDamage");
    }
  }
  throw new Error(`Unknown accessor: ${accessor}`);
}
